/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { InputAction, ModalController } from "../../../../viewModel/navigation";
import { UnityAppDispatch, UnityRootState } from "../../../../viewModel";
import {
  selectActiveOptionFocusIndex,
  setActiveOptionFocusIndex,
  selectActiveRecordingOption,
  confirmActiveOptionValue,
  closeOptionValue
} from "../../../../viewModel/myHub/seriesRecordingOptions";

/** Modal name constant for the HorizontalSelectionDialog modal. */
export const HORIZONTAL_SELECTION_DIALOG_MODAL_NAME: string =
  "HORIZONTAL_SELECTION_DIALOG";

/**
 * ModalController for the HorizontalSelectionDialog sub-panel.
 *
 * D-pad routing:
 *   NAV_LEFT  → move focus left (clamps at 0)
 *   NAV_RIGHT → move focus right (clamps at last option)
 *   NAV_OK    → confirm the focused value and close
 *   BACK      → discard and close
 *
 * All handlers return true to consume input so it never reaches the
 * Series Recording Options overlay behind the picker.
 */
export class HorizontalSelectionDialogController extends ModalController {
  private readonly mDispatch: UnityAppDispatch;
  private readonly mGetState: () => UnityRootState;

  public constructor(
    dispatch: UnityAppDispatch,
    getState: () => UnityRootState
  ) {
    super(HORIZONTAL_SELECTION_DIALOG_MODAL_NAME);
    this.mDispatch = dispatch;
    this.mGetState = getState;
  }

  protected initialize(): void {
    this.registerHandler(InputAction.NAV_UP, (): boolean => {
      return true;
    });

    this.registerHandler(InputAction.NAV_DOWN, (): boolean => {
      return true;
    });

    this.registerHandler(InputAction.NAV_LEFT, (): boolean => {
      const current: number = selectActiveOptionFocusIndex(this.mGetState());
      if (current > 0) {
        this.mDispatch(setActiveOptionFocusIndex(current - 1));
      }
      return true;
    });

    this.registerHandler(InputAction.NAV_RIGHT, (): boolean => {
      const state = this.mGetState();
      const current: number = selectActiveOptionFocusIndex(state);
      const option = selectActiveRecordingOption(state);
      const lastIndex: number =
        option !== undefined &&
        option.horizontalOptions !== undefined &&
        option.horizontalOptions.length > 0
          ? option.horizontalOptions.length - 1
          : 0;
      if (current < lastIndex) {
        this.mDispatch(setActiveOptionFocusIndex(current + 1));
      }
      return true;
    });

    this.registerHandler(InputAction.NAV_OK, (): boolean => {
      this.mDispatch(confirmActiveOptionValue());
      return true;
    });

    this.registerHandler(InputAction.BACK, (): boolean => {
      this.mDispatch(closeOptionValue());
      return true;
    });
  }
}
